import React from 'react';
import { VisibilityTrackerContainer } from '@noths/polaris-client-components';
import { FavouriteButton, SolidButton } from '@noths/polaris-client-ribbons-design-system';

import { FavouriteProduct } from 'src/redux/selectors';
import { ADD_TO_BASKET_CTA, BUY_GIFT_CARD_CTA, MAIN_PAGE_CTA_ID } from '../constants';
import { MAIN_PAGE_CTA_VISIBILITY_NAME } from '../tracking/events';
import * as styles from '../styles/ProductInfo.styles';

export interface AddToBasketButtonProps {
  product: FavouriteProduct;
  shouldShowDeliveryBlock: boolean;
  preventAddToBasketSubmit?: boolean;
  onBuyGiftCard: VoidFunction;
  updateFavourite: (product: number) => void;
  submitPersonalisationForm: VoidFunction;
}

export const AddToBasketButton = ({
  product,
  shouldShowDeliveryBlock,
  preventAddToBasketSubmit = false,
  onBuyGiftCard,
  updateFavourite,
  submitPersonalisationForm,
}: AddToBasketButtonProps) => (
  <VisibilityTrackerContainer sectionName={MAIN_PAGE_CTA_VISIBILITY_NAME}>
    <div
      css={[
        styles.ctaSectionWrapper,
        !shouldShowDeliveryBlock && styles.ctaSectionWrapperWithoutDeliveryBlock,
      ]}
    >
      <div css={styles.favouriteButtonWrapper}>
        <FavouriteButton
          css={styles.favouriteButton}
          onClick={() => updateFavourite(product.code)}
          active={product.isFavourited}
          size="large"
        />
      </div>
      {product.purchasable ? (
        <SolidButton
          type="submit"
          size="fullWidth"
          css={styles.ctaButton}
          onClick={() => !preventAddToBasketSubmit && submitPersonalisationForm()}
          id={MAIN_PAGE_CTA_ID}
        >
          {ADD_TO_BASKET_CTA}
        </SolidButton>
      ) : (
        <SolidButton
          css={styles.ctaButton}
          size="fullWidth"
          href="/gift-cards"
          id={MAIN_PAGE_CTA_ID}
          onClick={onBuyGiftCard}
        >
          {BUY_GIFT_CARD_CTA}
        </SolidButton>
      )}
    </div>
  </VisibilityTrackerContainer>
);
